import React from 'react'
import Modal from '@material-ui/core/Modal'
import { useSelector } from 'react-redux'
import apiChat from '../../../../../../../api/chat'
import MeetingAvtor from '../../../../RightContainer/components/MeetingAvtor'
import MeetingContainerAvtor from '../../../../RightContainer/components/MeetingContainerAvtor'
import closeIcon from '../../../../../../../assetss/img/closeModalIcon.svg'
import { useStyles } from './style'

const DialogModal = ({ open, onClose }) => {
  const classes = useStyles()
  const { chatUser } = useSelector(({ chat }) => chat)
  const { user } = useSelector(({ session }) => session)

  const acceptDateMeeting = type => {
    apiChat.acceptMeeting(user?.accessKey, chatUser?.meeting?.uuid, type)
      .then(() => onClose())
  }

  const userName = id => {
    if (id === chatUser?.users?.[0]?.uuid) {
      return chatUser?.users?.[1]?.name
    } else if (id === chatUser?.users?.[1]?.uuid) {
      return chatUser?.users?.[0]?.name
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      {user?.user?.uuid === chatUser?.authorUuid ? (
        <div className={classes.paper}>
          <img src={closeIcon} className={classes.closeIcon} onClick={onClose} />
          <MeetingContainerAvtor userName={userName} />
        </div>
      ) : (
        <div className={classes.paper}>
          {chatUser?.meeting?.status !== 'requested' && (
            <img src={closeIcon} className={classes.closeIcon} onClick={onClose} />
          )}
          {chatUser?.meeting?.uuid ? (
            chatUser?.meeting?.status === 'requested' ? (
              chatUser?.status === 'meeting' && (
                <MeetingAvtor ofEditIcon onAccept acceptDateMeeting={acceptDateMeeting} />
              )
            ) : chatUser?.meeting?.status === 'accepted' ? (
              chatUser?.status === 'scheduled' && (
                <MeetingAvtor ofEditIcon onAccept={false} title='Meeting has been scheduled on:' />
              )
            ) : null
          ) : null}
        </div>
      )}
    </Modal>
  )
}

export default DialogModal
